import React from 'react';

import * as analytics from 'analytics/Analytics';
import SidepanelItem from 'nav/sidepanel/listing/SidepanelItem';
import TFIActions from 'notebook/tfi/TFIActions';
import {TFIObject} from 'notebook/tfi/TFIConstants';
import TFIDragTarget from 'notebook/tfi/TFIDragTarget';
import TFIPreviewModal from 'notebook/tfi/TFIPreviewModal';
import TFIUtil from 'notebook/tfi/TFIUtil';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import fuzzydate from 'util/fuzzydate';

interface TFIObjectItemProps {
  tfiObject: TFIObject;
  isChild: boolean;
}

export default class TFIObjectItem extends React.Component<TFIObjectItemProps> {
  openTFIFolder = (): void => {
    analytics.track('tfi', 'listed_folder', {
      accountType: this.props.tfiObject.accountType,
    });
    TFIActions.listFolder(this.props.tfiObject.accountId, this.props.tfiObject.id);
  };

  openTFIFile = (): void => {
    analytics.track('tfi', 'previewed_file', {
      accountType: this.props.tfiObject.accountType,
    });
    TFIPreviewModal.open({
      tfiFile: this.props.tfiObject,
    });
  };

  renderSidepanelItem(): JSX.Element {
    return (
      <SidepanelItem
        icon={<BenchlingIcon icon={this.props.tfiObject.isFolder ? 'folder' : 'file'} />}
        isCompact={false}
        title={{text: this.props.tfiObject.name}}
        subTitle={
          TFIUtil.isTFIFile(this.props.tfiObject) && this.props.tfiObject.modifiedAt
            ? fuzzydate(this.props.tfiObject.modifiedAt, {
                days: 7,
                showTime: false,
                compact: true,
              })
            : null
        }
        onClick={this.props.tfiObject.isFolder ? this.openTFIFolder : this.openTFIFile}
        isExpandable={false}
        isChild={this.props.isChild}
      />
    );
  }

  render(): JSX.Element {
    if (this.props.tfiObject.isFolder) {
      return this.renderSidepanelItem();
    }
    return <TFIDragTarget tfiObject={this.props.tfiObject}>{this.renderSidepanelItem()}</TFIDragTarget>;
  }
}
